import createReducer from '../utils/createReducer';
import actions from '../actions/reviewsActions';
import ReviewsRecord from '../records/reviewsRecord';

const initialState = new ReviewsRecord();

const actionHandlers = {
    [actions.FETCH_REVIEWS_SUCCESS](state, {payload = {}}) {
        const {reviews, paging, isFetching} = payload;
        const {page, pageSize} = paging;
        const retrievedPageStart = pageSize * (page - 1) + 1;
        const retrievedPageEnd = pageSize * page;
        let newReviews = state.reviews.concat(reviews);
        // PDS, by default, pulls in 10 reviews initially.  This means it might not
        // line up with our second page.
        // If we see we don't have enough already to cover the second page, we trim off
        // the extra and concat on what we just retrieved.
        if (state.reviews.length >= retrievedPageStart && state.reviews.length < retrievedPageEnd) {
            newReviews = state.reviews.slice(0, pageSize).concat(reviews);
        } else if (state.reviews.length >= retrievedPageEnd) {
            // Note: There is a chance our page size could be small, like 3, and the
            // second page is already part of that initial set.
            // So, if the default was 10, and we just fetched page two of size 3,
            // then we already have those reviews, and won't touch them.
            newReviews = state.reviews;
        }
        return state.merge({paging, isFetching}).mergeIn(['reviews'], newReviews);
    },
    [actions.FETCH_REVIEWS_REQUEST_STARTED](state, {payload = {}}) {
        const {isFetching} = payload;

        return state.merge({isFetching});
    },
    [actions.FETCH_REVIEWS_FAILURE](state, {payload = {}}) {
        const {isFetching} = payload;

        return state.merge({isFetching});
    },
    [actions.EXPAND_REVIEW_CLICKED](state, {payload = {}}) {
        const {reviewId} = payload;

        return state.merge({reviewId});
    },
    [actions.SCROLL_REVIEWS_TOP](state, {payload = {}}) {
        const {scrollTop} = payload;
        return state.merge({scrollTop});
    },
    [actions.SET_PAGE_INDEX](state, {payload = {}}) {
        const {pageIndex} = payload;
        return state.merge({pageIndex});
    },
    [actions.REPORT_REVIEW_CLICKED](state, {payload = {}}) {
        const {reviewId} = payload;

        const updatedReviews = state.reviews.map((review) => {
            if (review.uuid === reviewId) {
                return {...review, isReportReviewActive: false};
            }
            return review;
        });

        return state.mergeIn(['reviews'], updatedReviews);
    },
    [actions.TRANSLATE_REVIEWS_SUCCESS](state, {payload = {}}) {
        const {reviews, page, isFetching} = payload;

        const {translatedReviewsMap} = state;
        const newTranslatedReviewsMap = Object.assign({}, translatedReviewsMap);
        newTranslatedReviewsMap[page] = reviews;
        return state.merge({isFetching}).mergeIn(['translatedReviewsMap'], newTranslatedReviewsMap);
    },
    [actions.UPDATE_FETCH_AUTO_TRANSLATED_REVIEWS](state, {payload = {}}) {
        const {fetchAutoTranslatedReviews} = payload;
        return state.merge({fetchAutoTranslatedReviews});
    }
};

export default createReducer(actionHandlers, initialState);
